export default class Menu
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-menu',
      wrapper: 'data-menu-wrapper',
      button: 'data-menu-dropdown',
      child: 'data-menu-child',
    };
    
    this.menu = document.querySelector(`[${this.settings.main}]`);
    if (!this.menu) return;
    this.open = false;
    
    return true;
  }
  
  setEvents()
  {
    const wrappers = this.menu.querySelectorAll(`[${this.settings.wrapper}]`);
    wrappers.forEach(wrapper => {
      const button = wrapper.querySelector(`[${this.settings.button}]`);
      button.addEventListener('click', (e) => {
        if (window.innerWidth < 1025) {
          e.preventDefault();
          e.stopPropagation();
        }

        this.toggleMenu(wrappers, wrapper)
      });
      
      if (window.innerWidth > 1025) {
        button.addEventListener('mouseenter', () => this.toggleMenu(wrappers, wrapper));
      }
    })
    
    document.addEventListener('click', (e) => this.closeMenu(e));
    
    if (window.innerWidth > 1025) {
      document.addEventListener('mouseover', (e) => this.closeMenu(e));
    }
  }
  
  closeMenu (e) {
    if (this.open && !e.target.closest('.header')) {
      this.menu.querySelectorAll(`[${this.settings.wrapper}]`).removeClass('active_menu');
      document.querySelector(`[data-blur]`).removeClass('active');
      this.open = false;
    }
  }
  
  toggleMenu(wrappers, wrapper) {
    wrappers.removeClass('active_menu');
    
    if (wrapper.hasClass('active_menu')) {
      document.querySelector(`[data-blur]`).removeClass('active');
      this.open = false;
    } else {
      this.menu.querySelectorAll(`[${this.settings.child}]`).removeClass('active_menu');
      wrapper.addClass('active_menu');
      document.querySelector(`[data-blur]`).addClass('active');
      this.open = true;
    }
  }
}
